import { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema, toTypedRxJsonSchema } from 'rxdb';

const userSchemaLiteral = {
  title: 'user schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 36,
      type: 'string',
    },
    userId: { type: 'string' },

    // no name
    email: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    displayName: { type: 'string' },
    phone: { type: 'string' },
    recoveryEmail: { type: 'string' },
    preferences: {
      type: 'object',
      properties: {
        originalBlockEditWarning: { type: 'boolean' },
        stream: { type: 'boolean' },
      },
    },
    analytics: {
      type: 'object',
      properties: {
        firstNoteGeneratedAt: { type: 'string' },
      },
    },

    // no aliases, tags

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
  },
  required: ['id', 'userId', 'email', 'createdAt', 'updatedAt'],
} as const;
const _userSchemaTyped = toTypedRxJsonSchema(userSchemaLiteral);

export type User = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _userSchemaTyped>;
export const userSchema: RxJsonSchema<User> = userSchemaLiteral;
